// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1YoRN","title":"Info_title__3MetU","selects":"Info_selects__3SEmN","requiredAsterisk":"Info_requiredAsterisk__kTKvY"};